// extracted by mini-css-extract-plugin
module.exports = {"page":"articles_page___ocLa","revision":"articles_revision__HpBcU"};